module.exports = __webpack_public_path__ + "img/top_movie.c703edf0.jpg";